<template>
  <div class="w-screen h-screen flex flex-col items-center justify-center" style="background-color: #020308">
    <!-- EMAIL VERIFIED STATE -->
    <div v-if="isEmailVerified" class="flex flex-col items-center w-full pb-10" style="max-width: 430px">
      <img src="../../assets/images/foreplay-logo.png" style="width: 136px; height: 40px;" />
      <div class="flex items-center justify-center w-11 h-11 rounded-xl border-2 border-white mt-9">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M7 13L10 16L17 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <BaseText type="heading" size="md" class="text-white mt-9">
        Email Verified Successfully
      </BaseText>
      <BaseText type="body" size="md" class="text-neutral-alpha-650 mt-1 text-center">
        You can now close this page
      </BaseText>
      <!-- <router-link :to="{ name: hasTeamInvitation ? 'DiscoveryView' : 'UserOnboardView' }" class="submit-button mt-6 px-4 py-2 h-10 bg-white flex items-center justify-center transition duration-200 hover:bg-opacity-90">
        <BaseText type="heading" size="sm">
          Continue to {{ hasTeamInvitation ? 'App' : 'Onboarding' }}
        </BaseText>
      </router-link> -->
    </div>

    <!-- NEEDS VERIFICATION STATE -->
    <div v-else class="flex flex-col items-center w-full pb-6" style="max-width: 430px">
      <!-- Logo -->
      <img src="../../assets/images/foreplay-logo.png" style="width: 136px; height: 40px;" class="mb-12" />
      <!-- Email Directions -->
      <EmailSentDirections 
        :to-email="toEmail"
        subheading="We sent you an activation link for Foreplay. Please check your spam folder or use the shortcuts below"
        resend-text="verification"
        @resend="sendVerificationEmail(toEmail)"
      />
      <!-- Login to different account -->
      <button class="mt-6 transition-colors text-neutral-alpha-600 hover:text-white" @click="handleLogout">
        <BaseText type="body" size="sm">
          Go back to Sign In
        </BaseText>
      </button>
    </div>
  </div>
</template>

<script>
import firebase from '@/api/config/FirebaseConfig'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import router from '@/router'
import FunctionsAPI from '@/api'

import EmailSentDirections from '../../components/account/EmailSentDirections.vue'

export default {
  name: 'VerifyEmailView',
  components: {
    EmailSentDirections
  },
  data () {
    return {
      toEmail: null
    }
  },
  created () {
    const user = firebase.auth().currentUser
    if (user) {
      if (this.isEmailVerified) return
      if (user.emailVerified) {
        this.SET_IS_EMAIL_VERIFIED(true)
        return
      }
      this.toEmail = user.email
      this.sendVerificationEmail(this.toEmail)

      // Fetch the user's pending invitations
      this.fetchUserInvitations()

      // Listen for email verification status
      this.bc = new BroadcastChannel('email-verification-status')
      this.bc.onmessage = (event) => {
        const { isEmailVerified } = event.data
        this.SET_IS_EMAIL_VERIFIED(isEmailVerified)
        
        // Reload the firebase auth user
        firebase.auth().currentUser.reload()
      }
    } else {
      this.$showAlert({
        type: 'error',
        message: "Couldn't authenticate. Please try again."
      })
      router.push({ name: 'LoginView' })
    }
  },
  beforeDestroy () {
    if (this.bc) this.bc.close()
  },
  computed: {
    ...mapGetters('AuthModule', ['isEmailVerified', 'getPendingInvitations']),
    hasTeamInvitation () {
      return this.getPendingInvitations?.length > 0
    }
  },
  methods: {
    ...mapMutations('AuthModule', ['SET_IS_EMAIL_VERIFIED']),
    ...mapActions('AuthModule', ['logoutUser', 'fetchUserInvitations']),
    sendVerificationEmail (email) {
      FunctionsAPI.Transactions.sendEmailVerification(email)
    },
    handleLogout () {
      this.logoutUser()
      router.push({ name: 'LoginView' })
    }
  },
  metaInfo: {
    title: 'Verify Your Email | Foreplay.co'
  }
}
</script>

<style scoped>
.mail-button {
  background-color: transparent;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  transition: background-color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.mail-button:hover {
  background-color: rgba(255, 255, 255, 0.12);
  box-shadow: none;
}

.submit-button {
  color: #13151A;
  border-radius: 10px;
}
</style>